import React, { useState, useEffect } from "react";
import "../scss/IA.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Overall } from "./IACover";
import IASaveModal from "./IASaveModal";
import html2canvas from "html2canvas";
import useFileUpload from "../api/hooks/useFileUpload";
import {
  EditorProvider,
  useEditor,
  useEditorActions,
  SET_AI_DATA,
} from "../context/editor";
import { useTranslation } from "react-i18next";
function IATab({ analysis }) {
  const { t } = useTranslation("common");
  const [editorState, editorDispatch] = useEditor();
  const {
    tipo,
    arrendador,
    rep_arrendador,
    arrendatario,
    rep_arrendatario,
    dir_inmueble,
    donde_se_firma,
    estacionamiento,
    fecha_firma,
    inicio_renta,
    limite_pago,
    mascotas,
    plazo_renta,
    renta_mante_mensual,
    tribunales,
    comprador,
    confidencialidad,
    escrituración,
    monto,
    rep_vendedor_1,
    rep_vendedor_2,
    vendedor,
  } = analysis;
  const [step, setStep] = useState(0);
  const [CompraventaAr, setCompraventaAr] = useState(0);
  const [ArrendamientoAr, setArrendamientoAr] = useState(0);
  useEffect(() => {
    const arrendamientoArr = Object.keys(analysis).filter(
      (x) =>
        x !== "vendedor" ||
        x !== "comprador" ||
        x !== "rep_vendedor_1" ||
        x !== "rep_vendedor_2" ||
        x !== "monto" ||
        x !== "escrituración" ||
        x !== "confidencialidad"
    ).length;
    const CompraventaArr = Object.keys(analysis).filter(
      (x) =>
        x === "vendedor" ||
        x === "comprador" ||
        x === "rep_vendedor_1" ||
        x === "rep_vendedor_2" ||
        x === "monto" ||
        x === "escrituración" ||
        x === "confidencialidad"
    ).length;
    console.log(arrendamientoArr);
    console.log(CompraventaArr);
    setArrendamientoAr(arrendamientoArr);
    setCompraventaAr(CompraventaArr);
  }, [analysis]);
  const [SaveModal, setSaveModal] = useState(false);
  const [saveOnDocs, setSaveOnDocs] = useState(false);
  const [saveOnContract, setSaveOnContract] = useState(false);
  const [pic1src, setPic1src] = useState("");
  const [pic2src, setPic2src] = useState("");
  const [pic3src, setPic3src] = useState("");
  const [other, setOther] = useState(false);
  const [loadingImageUpload, setloadingImageUpload] = useState(false);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
  const [filetoUpload, setfiletoUpload] = useState("");
  const handleSave = () => {
    if (saveOnContract) {
      setloadingImageUpload(true);
    }
    if (!saveOnContract) {
      setSaveModal(true);

      editorDispatch({
        type: SET_AI_DATA,
        data: {
          saveOnDocs: saveOnDocs,
          sugerencias: sugerencias,
        },
      });
    }
  };
  const [sugerencias, setSugerencias] = useState("");
  useEffect(() => {
    if (loadingImageUpload === true && tipo === "arrendamiento") {
      setfiletoUpload("pic1");
      printScreen();
    }
    if (loadingImageUpload === true && tipo === "compraventa") {
      setfiletoUpload("pic3");
      printScreen();
    }
  }, [loadingImageUpload]);
  useEffect(() => {
    if (file1 !== null && filetoUpload === "pic1") {
      uploadFile({ file: file1 });
    }
  }, [file1, filetoUpload]);
  useEffect(() => {
    if (file2 !== null && filetoUpload === "pic2") {
      uploadFile({ file: file2 });
    }
  }, [file2, filetoUpload]);
  useEffect(() => {
    if (file3 !== null && filetoUpload === "pic3") {
      uploadFile({ file: file3 });
    }
  }, [file3, filetoUpload]);
  useEffect(() => {
    console.log(editorState);
  }, [editorState]);

  useEffect(() => {
    if (pic1src !== "" && pic2src !== "") {
      setSaveModal(true);
      editorDispatch({
        type: SET_AI_DATA,

        data: {
          pics: [pic1src, pic2src],
          saveOnDocs: saveOnDocs,
          sugerencias: sugerencias,
        },
      });
    }
  }, [pic1src, pic2src]);
  useEffect(() => {
    if (pic3src !== "" && tipo === "compraventa") {
      setSaveModal(true);
      editorDispatch({
        type: SET_AI_DATA,

        data: {
          pics: [pic3src],
          saveOnDocs: saveOnDocs,
          sugerencias: sugerencias,
        },
      });
    }
  }, [pic3src]);

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    setFile1(new File([u8arr], filename, { type: mime }));
    return new File([u8arr], filename, { type: mime });
  }
  function dataURLtoFile2(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    setFile2(new File([u8arr], filename, { type: mime }));
    return new File([u8arr], filename, { type: mime });
  }
  function dataURLtoFile3(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    setFile3(new File([u8arr], filename, { type: mime }));
    return new File([u8arr], filename, { type: mime });
  }
  const printScreen = () => {
    if (tipo === "arrendamiento") {
      const IACoverToPrint1 = document.getElementById("IACover--pic1");
      const IACoverToPrint2 = document.getElementById("IACover--pic2");
      html2canvas(IACoverToPrint1).then((canvas) => {
        var myImage = canvas.toDataURL();
        if (tipo === "arrendamiento") {
          dataURLtoFile(myImage, "IACoverPic.png");
        }
      });
      html2canvas(IACoverToPrint2).then((canvas) => {
        var myImage = canvas.toDataURL();
        if (tipo === "arrendamiento") {
          dataURLtoFile2(myImage, "IACoverPic2.png");
        }
      });
    }
    if (tipo === "compraventa") {
      const IACoverToPrint3 = document.getElementById("IACover--compraventa");

      html2canvas(IACoverToPrint3).then((canvas) => {
        var myImage = canvas.toDataURL();
        if (tipo === "arrendamiento") {
          dataURLtoFile3(myImage, "IACoverPic3.png");
        }
      });
    }
  };

  // ids
  // IACover--pic1
  // IACover--pic2
  // IACover--compraventa

  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      if (filetoUpload === "pic1") {
        setPic1src(url);
        setfiletoUpload("pic2");
      }
      if (filetoUpload === "pic2") {
        setPic2src(url);
      }
      if (filetoUpload === "pic3") {
        setPic3src(url);
      }
    },
    onError: (error) => {
      console.log("Error al Adjuntar");
    },
  });
  const checkData = (name) => {
    const items = Object.entries(analysis).filter((x) =>
      x?.[0].slice(0, name.length).includes(name)
    );
    if (items.length > 0) {
      return true;
    }
    if (items.length === 0) {
      return false;
    }
  };
  return (
    <div className="IATab">
      <IASaveModal
        isOpen={SaveModal}
        toggle={() => setSaveModal(!SaveModal)}
        message={saveOnContract ? 1 : !saveOnContract && 2}
      />
      <div className="selection--bar">
        <div className={step === 0 ? "active" : ""} onClick={() => setStep(0)}>
          {t("IACover.select.0")}
        </div>
        <div className={step === 1 ? "active" : ""} onClick={() => setStep(1)}>
          {t("IACover.select.1")}
        </div>
      </div>
      {step === 0 && (
        <>
          {tipo === "arrendamiento" ? (
            <div className="content">
              <div className="headerIA">
                <div className="item">
                  <p className="font-weight-bold">{t("IACover.text.0")}</p>
                  <span className="font-weight-bold">
                    {tipo === "arrendamiento" ? "Arrendamiento" : tipo}
                  </span>
                </div>
              </div>
              <div className="IA--Tab--content">
                <p className="font-weight-bold">
                  {t("IACover.arrendamiento.0")}
                </p>
                <div className="table1">
                  <div className="textContent--noHeader">
                    <p>{t("IACover.arrendamiento.1")}</p>
                    <p>{t("IACover.arrendamiento.2")}</p>
                  </div>
                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("fecha_firma") && <Check />}</td>
                      <td>{!checkData("fecha_firma") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("donde_se_firma") && <Check />}</td>
                      <td>{!checkData("donde_se_firma") && <Check />}</td>
                    </tr>
                  </table>
                </div>
                <div className="table1">
                  <div>
                    <p className="font-weight-bold">
                      {t("IACover.arrendamiento.3")}
                    </p>
                    <p>{t("IACover.arrendamiento.4")}</p>
                    <p>{t("IACover.arrendamiento.5")}</p>

                    <p>{t("IACover.arrendamiento.6")}</p>
                    <p>{t("IACover.arrendamiento.7")}</p>
                  </div>
                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("arrendador") && <Check />}</td>
                      <td>{!checkData("arrendador") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("arrendatario") && <Check />}</td>
                      <td>{!checkData("arrendatario") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("rep_arrendador") && <Check />}</td>
                      <td>{!checkData("rep_arrendador") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("rep_arrendatario") && <Check />}</td>
                      <td>{!checkData("rep_arrendatario") && <Check />}</td>
                    </tr>
                  </table>
                </div>
                <div className="table1">
                  <div className="textContent--noHeader">
                    <p>{t("IACover.arrendamiento.8")}</p>
                    <p>{t("IACover.arrendamiento.9")}</p>

                    <p>{t("IACover.arrendamiento.10")}</p>
                  </div>

                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("dir_inmueble") && <Check />}</td>
                      <td>{!checkData("dir_inmueble") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("renta_mante_mensual") && <Check />}</td>
                      <td>{!checkData("renta_mante_mensual") && <Check />}</td>
                    </tr>

                    <tr height="30px">
                      <td>{checkData("plazo_renta") && <Check />}</td>
                      <td>{!checkData("plazo_renta") && <Check />}</td>
                    </tr>
                  </table>
                </div>
                <div className="table1">
                  <div>
                    <p className="font-weight-bold">
                      {t("IACover.arrendamiento.11")}
                    </p>
                    <p>{t("IACover.arrendamiento.12")}</p>
                  </div>

                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("inicio_renta") && <Check />}</td>
                      <td>{!checkData("inicio_renta") && <Check />}</td>
                    </tr>
                  </table>
                </div>
                <div className="table1">
                  <div>
                    <p className="font-weight-bold">
                      {t("IACover.arrendamiento.13")}
                    </p>
                    <p>{t("IACover.arrendamiento.14")}</p>
                  </div>
                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("tribunales") && <Check />}</td>
                      <td>{!checkData("tribunales") && <Check />}</td>
                    </tr>
                  </table>
                </div>
                <div className="table1">
                  <div>
                    <p className="font-weight-bold">
                      {" "}
                      {t("IACover.arrendamiento.15")}
                    </p>
                    <p>{t("IACover.arrendamiento.16")}</p>
                    <p>{t("IACover.arrendamiento.17")}</p>
                    <p>{t("IACover.arrendamiento.18")}</p>
                  </div>

                  <table>
                    <tr height="30px">
                      <th>{t("IACover.elementExist.0")}</th>
                      <th>{t("IACover.elementExist.1")}</th>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("estacionamiento") && <Check />}</td>
                      <td>{!checkData("estacionamiento") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("mascotas") && <Check />}</td>
                      <td>{!checkData("mascotas") && <Check />}</td>
                    </tr>
                    <tr height="30px">
                      <td>{checkData("limite_pago") && <Check />}</td>
                      <td>{!checkData("limite_pago") && <Check />}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            tipo === "compraventa" && (
              <>
                <div className="content">
                  <div className="headerIA">
                    <div className="item">
                      <p className="font-weight-bold">{t("IACover.text.0")}</p>
                      <span className="font-weight-bold">
                        {tipo === "compraventa" ? "Compraventa" : tipo}
                      </span>
                    </div>
                  </div>
                  <div className="IA--Tab--content">
                    <p className="font-weight-bold">
                      {t("IACover.arrendamiento.0")}
                    </p>

                    <div className="table1">
                      <div>
                        <p className="font-weight-bold">
                          {t("IACover.compraventa.1")}
                        </p>
                        <p>{t("IACover.compraventa.2")}</p>
                        <p>{t("IACover.compraventa.3")}</p>

                        <p>{t("IACover.compraventa.4")}</p>
                        <p>{t("IACover.compraventa.5")}</p>
                      </div>
                      <table>
                        <tr height="30px">
                          <th>{t("IACover.elementExist.0")}</th>
                          <th>{t("IACover.elementExist.1")}</th>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("comprador") && <Check />}</td>
                          <td>{!checkData("comprador") && <Check />}</td>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("vendedor") && <Check />}</td>
                          <td>{!checkData("vendedor") && <Check />}</td>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("rep_comprador") && <Check />}</td>
                          <td>{!checkData("rep_comprador") && <Check />}</td>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("rep_vendedor") && <Check />}</td>
                          <td>{!checkData("rep_vendedor") && <Check />}</td>
                        </tr>
                      </table>
                    </div>
                    <div className="table1">
                      <div className="textContent--noHeader">
                        <p>{t("IACover.compraventa.6")}</p>
                        <p>{t("IACover.compraventa.7")}</p>

                        <p>{t("IACover.compraventa.8")}</p>
                      </div>

                      <table>
                        <tr height="30px">
                          <th>{t("IACover.elementExist.0")}</th>
                          <th>{t("IACover.elementExist.1")}</th>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("condifencialidad") && <Check />}</td>
                          <td>{!checkData("condifencialidad") && <Check />}</td>
                        </tr>
                        <tr height="30px">
                          <td>{checkData("escrituración") && <Check />}</td>
                          <td>{!checkData("escrituración") && <Check />}</td>
                        </tr>

                        <tr height="30px">
                          <td>{checkData("monto") && <Check />}</td>
                          <td>{!checkData("monto") && <Check />}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )
          )}
        </>
      )}
      {step === 1 && tipo && (
        <div className="IATab--form">
          <form
            action="
            "
          >
            <label htmlFor="">
              <input
                type="checkbox"
                onClick={() => setSaveOnContract(!saveOnContract)}
              />
              {t("IACover.configuration.0")}
            </label>
            {/* <label htmlFor="">
              <input
                type="checkbox"
                onClick={() => setSaveOnDocs(!saveOnDocs)}
              />
              Guardar en Documentos
            </label> */}
            <p>{t("IACover.configuration.1")}</p>
            <select
              onChange={(e) => {
                console.log(e.target.value);
              }}
              disabled={other}
            >
              <option hidden selected>
                {t("IACover.configuration.2")}
              </option>
              <option value="Inversion" onSel>
                {t("IACover.configuration.3")}
              </option>
              <option value="Laborales">{t("IACover.configuration.4")}</option>
            </select>
            <label htmlFor="">
              <input type="checkbox" onClick={() => setOther(!other)} />
              {t("IACover.configuration.5")}
            </label>
            <textarea
              name=""
              id=""
              className="textArea"
              onChange={(e) => {
                setSugerencias(e.target.value);
              }}
              disabled={!other}
            ></textarea>
            <button
              onClick={(e) => {
                handleSave();
                e.preventDefault();
              }}
            >
              {t("IACover.configuration.6")}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
function Check() {
  return (
    <div className="IATAB--check">
      <FontAwesomeIcon
        icon={faCheck}
        color="#ffffff"
        className="IATAB--check--icon"
      />
    </div>
  );
}

export default IATab;
